goog.provide('el8.ptdata.addendums');

goog.require('el8.model.base');
goog.require('el8.service.tz');
goog.require('el8.util.string');
goog.require('el8.data.referencedUsers');

el8.ptdata.addendums = (function() {

    var _class = function(spec) {
        spec = spec || {};
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addIntProperty("referencedDocumentId", true);
    _class.addStringProperty("text", true);

    _class.prototype.getReferencedDocument = function() {
        return el8.ptdata.fetchById(this.getReferencedDocumentId());
    };

    _class.prototype.getNoteSummary = function() {
        var summary = !this.getReferencedDocumentId() ? '' :
            el8.ptdata.fetchById(this.getReferencedDocumentId()).getNoteSummary();
        return summary + ': ' + this.getText();
    };

    _class.prototype.asSoyMap = function() {
        return {
            modelClass: this.getModelClass(),
            feedItemId: this.getFeedItemId(),
            text: this.getText(),
            signUserName: this.getSignUserName(),
            signDate: el8.service.tz.soyStr(this.getSignDate()),
            docId: this.getReferencedDocumentId()
        };
    };

    var that = new el8_EntitySet({
        model: function(spec) {
            return new _class(spec);
        },
        items: [],
        observable: true,
        defaultFetch: false,
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                data: {data: JSON.stringify(item.asMap(true))},
                url: el8Globals['PATIENT_PATH']+'addendum/',
                success: function(data) {
                    item.populate(data);
                    if (successCb) { successCb(item); }
                }
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8Globals['PATIENT_PATH']+'addendum/' + item.getId() + '/',
                success: function() {
                    if (item.getReferencedDocumentId()) {
                        // refreshing referenced document to remove any references from that document to this addendum
                        el8.ptdata.refreshDocById(item.getReferencedDocumentId());
                    }
                    if (successCb) {
                        successCb();
                    }
                },
                error: errorCb
            });
        }
    });

    return that;
})();
